"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPostAuthServiceMessage = void 0;
const react_1 = require("react");
const AuthMessageProvider_context_1 = require("./AuthMessageProvider.context");
const useGetPostAuthServiceMessage = (eventType, callback) => {
    const { subscribe, unsubscribe } = (0, react_1.useContext)(AuthMessageProvider_context_1.AuthMessageContext);
    (0, react_1.useEffect)(() => {
        const id = subscribe({ eventType, callback });
        return () => unsubscribe(id);
    }, [callback, eventType, subscribe, unsubscribe]);
};
exports.useGetPostAuthServiceMessage = useGetPostAuthServiceMessage;
//# sourceMappingURL=AuthMessageProvider.hooks.js.map